export const environment = {
  production: true,
  environment: 'production',
  dashboardRefreshIntervalSeconds: 60,
  portalAppBaseUrl: 'https://portal.salvehealth.com',
  portalDomain: 'salvehealth.co',
  // SA-8857: the new Clinic Portal, linked from the sidebar. Empty disables the link.
  newPortalUrl: 'https://clinicportal.salvehealth.co',
  // SA-8857: shared parent domain for the Cognito session cookies, so the new portal
  // on a sibling subdomain sees the same session. null keeps Amplify on localStorage.
  authCookieDomain: '.salvehealth.co',
  mfeCdnBaseUrl: 'https://d1pkf2ztopxzq7.cloudfront.net',
  videoCallComponentUrl:
    'https://d1pkf2ztopxzq7.cloudfront.net/salve-clinic-video-call.js',
  messagingComponentUrl:
    'https://d1pkf2ztopxzq7.cloudfront.net/salve-clinic-messaging.js',
  messagingDashboardComponentUrl:
    'https://d1pkf2ztopxzq7.cloudfront.net/salve-clinic-messaging-dashboard.js',
  patientFormsComponentUrl:
    'https://d1pkf2ztopxzq7.cloudfront.net/salve-clinic-patient-forms.js',
  formDesignerComponentUrl:
    'https://d1pkf2ztopxzq7.cloudfront.net/salve-clinic-form-designer.js',
  api: {
    resolve: {
      endpoint: 'https://public.salvehealth.co/resolve'
    },
    public: {
      endpoint: 'https://public.salvehealth.co/public'
    },
    content: {
      endpoint: 'https://content.salvehealth.co/'
    },
    messagingWs: {
      endpoint: 'wss://mnuc1duxuf.execute-api.eu-west-2.amazonaws.com/Prod'
    },
    portal: {
      endpoint: 'https://portal.salvehealth.co/v1/'
    },
    portalPublic: {
      endpoint: 'https://portal.salvehealth.co/public/v1/'
    },
    s3Proxy: {
      endpoint: 'https://s3presign.salvehealth.co/'
    },
    status: {
      endpoint: 'https://clinicsynchealth.salvehealth.co/status'
    }
  },
  auth: {
    identityPoolId: 'eu-west-2:5424ce93-3423-4a7f-9a22-f62069069b68',
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_r1nNU4mlZ',
    userPoolWebClientId: '5q8big4akbeagiuvejh3fa1cnb',
    authenticationFlowType: 'CUSTOM_AUTH'
  },
  features: {
    payment: false,
    videoCalls: false,
    assignClinicUser: false
  },
  sentry: {
    dsn: 'https://3217f81fa9aa4d198d1b48d3549e5ffd@o220829.ingest.us.sentry.io/1366588'
  }
};
